import { Component, ViewChild, AfterViewInit, Inject, Renderer2 } from '@angular/core';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DxSchedulerComponent } from 'devextreme-angular';
import { AcceptRejectDialogComponent } from '../accept-reject-dialog/accept-reject-dialog.component';
import { DOCUMENT } from '@angular/common';
import { AppSolicitudesService } from '../../core/services/appSolicitudes.service';
import { LivesSessionHelper } from '../../core/helper/livesSessionHelper';


const iconSelect = {
  'Día de cumpleaños': "birthday-cake",
  'Permiso retribuido': "stamp",
  'Mesa electoral': "vote-yea",
  'Vacaciones': "umbrella-beach",
  'Matrimonio': "ring",
  'Alumbramiento del cónyugue': "baby",
  'Visita médica': "briefcase-medical",
  'Visita Médico': "briefcase-medical",
  'Referencia de candidatos': "user-friends",
  'Permiso retribuído por evento familiar': "users",
  'Cambio de domicilio': "home",
  'Permiso en período gestacional': "baby-carriage",
  'Intervención quirúrgica del cónyugue, padres e hijos': "hospital-user",
  'Intervención quirúrgica familiar primer grado consanguinidad': "hospital-user",
  'Día libre': "calendar-day",
  'Bienestar social': "laugh-beam",
};

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss'],
  providers: [AppSolicitudesService]
})
export class CalendarioComponent implements AfterViewInit {
  @ViewChild(DxSchedulerComponent, { static: false }) scheduler!: DxSchedulerComponent;

  constructor(
    protected _messageDialog: MessageDialog,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<CalendarioComponent>,
    private renderer: Renderer2,
    private dialog: MatDialog,
    protected _appSolicitudesService: AppSolicitudesService,
    private _livesSession: LivesSessionHelper,

  ) {
    this.filtros = this.inputData.preFilters || { tipo: [], empleado: [], empresa: [], estado: ['Pendiente', 'Aprobado'], centro: [] };
    this.disableEdit = this.inputData.disableEdit || false;
  }
  currentView: string = 'month';
  currentDate: Date = new Date();
  maxAppointments: number | null = 2;
  disableEdit: false;
  loading: boolean = false;
  dateFilterReq = false;
  dateFilterStart: Date | null = null;
  dateFilterEnd: Date | null = null;


  appointments = this.inputData.appointments
    .filter((item: any) => item.type !== "Cambio de datos" && item.type !== "Anticipo")
    .map((item: any) => {
      const start = new Date(item.startDate);
      const end = new Date(item.endDate);

      const formatTime = (date: Date) =>
        date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });

      return {
        ...item,
        text: item.user?.fullName || '',
        startDate: start,
        endDate: end,
        roomId: item.stateHr?.requestState1,
        type: item.type,
        profileImage: item.user?.profileImage?.imageData,
        icon: iconSelect[item.type] ?? 'certificate',
        allDay: item.duration === null,
        timeRange: `${formatTime(start)} - ${formatTime(end)}`
      };
    });

  resourcesData = [
    { text: 'Pendiente', id: 0, color: '#eb8f00' },
    { text: 'Aceptado', id: 1, color: '#4caf50' },
    { text: 'Rechazado', id: 2, color: '#d63939' }
  ];

  //Filtros
  popupVisible = false;
  filtros = { tipo: [], empleado: [], empresa: [], estado: [], centro: [] };
  estados = ['Pendiente', 'Aprobado', 'Rechazado'];

  // Arrays dinámicos 
  tipos: string[] = [];
  centros: string[] = [];
  empleados: string[] = [];
  empresas: string[] = [];

  ngAfterViewInit() {
    this.updateMaxAppointments();
    this.getUniqueValues();
    this.openDate();
  }

  ngOnInit() {
    this.dateFilterReq = this.inputData.dataFiltered || false;

    if (this.inputData.nullData) {
      this.getRequests({
        date: this.currentDate,
        employee: this.inputData.employee,
        companyCode: this.inputData.companyCode,
        companyId: this.inputData.companyId
      });
    } else {
      this.aplicarFiltros();
    }
  }


  onSchedulerReady(e: any) {
    const toolbarElement = e.component.element().querySelector('.dx-toolbar-before');
    const centerElement = e.component.element().querySelector('.dx-toolbar-center');
    const navigatorElement = e.component.element().querySelector('.dx-scheduler-navigator');

    // Asegurar que la barra de herramientas tenga una disposición en fila
    if (toolbarElement) {
      this.renderer.setStyle(toolbarElement, 'display', 'flex');
      this.renderer.setStyle(toolbarElement, 'flex-direction', 'row-reverse');
      this.renderer.setStyle(toolbarElement, 'gap', '1em');
    }

    // Mover el selector de fecha (dx-scheduler-navigator) a dx-toolbar-center
    if (navigatorElement && centerElement) {
      centerElement.appendChild(navigatorElement);
    }

    // Crear botón de leyenda solo si no existe
    if (toolbarElement && !toolbarElement.querySelector('.custom-legend-button')) {
      const buttonContainer = document.createElement('div');
      buttonContainer.classList.add('custom-legend-button');

      const button = document.createElement('button');
      button.classList.add('btn', 'btn-primary', 'btn-sm', 'btn-add', 'dx-item', 'dx-toolbar-item', 'dx-toolbar-button', 'legend-button');
      button.addEventListener('click', () => this.mostrarLeyendaPopup());

      // Agregar contenido al botón
      button.innerHTML = `
      <i class="dx-icon-info legend-info-button"></i> 
      <span> Leyenda </span>
       
    `;

      buttonContainer.appendChild(button);
      toolbarElement.insertBefore(buttonContainer, toolbarElement.firstChild);
    }

    // Agregar botón de Filtros si no existe
    if (!toolbarElement.querySelector('.custom-filters-button')) {
      const filtersButtonContainer = document.createElement('div');
      filtersButtonContainer.classList.add('custom-filters-button');

      const filtersButton = document.createElement('button');
      filtersButton.classList.add('btn', 'btn-primary', 'btn-sm', 'btn-add', 'dx-item', 'dx-toolbar-item', 'dx-toolbar-button', 'filters-button');
      filtersButton.addEventListener('click', () => this.abrirFiltros());

      filtersButton.innerHTML = `
      <i class="dx-icon-filter filters-icon"></i> 
      <span> Filtros </span>
    `;

      filtersButtonContainer.appendChild(filtersButton);
      toolbarElement.insertBefore(filtersButtonContainer, toolbarElement.firstChild);
    }

  }

  onAppointmentClick(e: any) {
    const targetElement = e.event.target as HTMLElement;
    // Verifica si se hizo clic en el botón "Ver más" dentro de la celda del scheduler
    const isMoreButton = targetElement.closest('.dx-scheduler-appointment-collector');

    if (!isMoreButton) {
      e.cancel = true; // Cancela el tooltip cuando no es el botón "Ver más"
    }

    // Verificar si el usuario puede editar la cita
    if (!this.canEditRequest(e.appointmentData)) {
      e.cancel = true;
      targetElement.style.cursor = 'not-allowed'; // Cambia el cursor a prohibido
      return;
    }

    !this.disableEdit && this.onClickManage(e.appointmentData); //Si no está deshabilitado 
  }

  onAppointmentDblClick(e: any) {
    e.cancel = true; // Cancela la apertura del editor de eventos por defecto
  }

  onAppointmentFormOpening(e: any) {
    e.cancel = true; // Cancela el modal de edición del evento
  }



  onClickManage(appointment: any) {
    // Cierra el calendario antes de abrir el popup de aceptación/rechazo
    this.dialogRef.close();
    const previousDateFilterReq = this.dateFilterReq;
    // Abre el popup de AcceptRejectDialogComponent
    const dialogRef = this.dialog.open(AcceptRejectDialogComponent, {
      width: '90%',
      data: {
        data: [appointment],
        calendarData: this.inputData.appointments
      }
    });

    // Aplicar estilos si es necesario
    setTimeout(() => {
      const dialogContainers = this.document.querySelectorAll('.mat-dialog-container');
      if (dialogContainers[0]) {
        this.renderer.setStyle(dialogContainers[0], 'background-color', '#dadada');
        this.renderer.setStyle(dialogContainers[0], 'max-height', '90vh');
        this.renderer.setStyle(dialogContainers[0], 'overflow-y', 'auto');
        this.renderer.addClass(dialogContainers[0], 'scrollable-section');
      }
      if (dialogContainers[1]) {
        this.renderer.setStyle(dialogContainers[1], 'background-color', '#dadada');
      }
    });

    // Cuando se cierre AcceptRejectDialogComponent, volver a abrir el calendario
    dialogRef.afterClosed().subscribe(() => {
      this.dateFilterReq = previousDateFilterReq;

      this.reopenCalendar();
    });
  }

  reopenCalendar() {

    const currentView = this.currentView;
    let visibleRange = this.scheduler?.instance.getStartViewDate();
    const visibleStartDate = this.scheduler?.instance.getStartViewDate(); // Inicio del rango visible
    const visibleEndDate = this.scheduler?.instance.getEndViewDate(); // Fin del rango visible

    if (currentView === 'month' && visibleStartDate && visibleEndDate) {
      // Calcula la fecha central entre el inicio y el fin del rango visible
      visibleRange = new Date((visibleStartDate.getTime() + visibleEndDate.getTime()) / 2);
    }

    const dialogRef = this.dialog.open(CalendarioComponent, {
      width: '100%',
      data: {
        appointments: this.inputData.appointments,
        preFilters: this.filtros,
        disableEdit: this.disableEdit,
        dataFiltered: this.dateFilterReq
      }
    });

    setTimeout(() => {
      this.applyDialogStyles([0, 1]);
    });

    // Esperar a que el componente se inicialice completamente antes de establecer la fecha
    dialogRef.afterOpened().subscribe(() => {
      if (visibleRange) {
        dialogRef.componentInstance.scheduler?.instance.option('currentDate', visibleRange);
      }
    });

    dialogRef.componentInstance.dateFilterReq = this.dateFilterReq;

    // llamar a getRequests() para obtener y filtrar los datos
    dialogRef.componentInstance.getRequests({
      date: this.currentDate,
      employee: this.inputData.employee,
      companyCode: this.inputData.companyCode,
      companyId: this.inputData.companyId,
      reOpenCalendar: true
    });;

  }

  openDate() {
    if (this.inputData.startDate) {
      const targetDate = new Date(this.inputData.startDate); // Usar directamente la fecha del input

      this.dialogRef.afterOpened().subscribe(() => {
        this.dialogRef.componentInstance.scheduler?.instance.option('currentDate', targetDate);
      });
    }
  }


  onOptionChanged(e: any) {
    if (e.name === 'currentView') {
      this.currentView = e.value;
      this.updateMaxAppointments();
    }

    if (e.name === 'currentDate' && this.dateFilterReq) {
      this.getRequests({
        date: e.value, // Se agrega la fecha actual
        employee: this.inputData.employee,
        companyCode: this.inputData.companyCode,
        companyId: this.inputData.companyId
      });
    }
  }

  closePopUp() {
    this.dialogRef.close();
  }

  updateMaxAppointments() {
    const newValue = this.currentView === 'month' ? 2 : 1;

    if (this.scheduler?.instance) {
      this.scheduler.instance.option('maxAppointmentsPerCell', newValue);
    }
  }

  getRequests({ date, employee, companyCode, companyId, reOpenCalendar = false }: { date?: Date; employee?: any; companyCode?: any; companyId?: any, reOpenCalendar?: boolean }) {


    const hasPreviousData = this.inputData.appointments && this.inputData.appointments.length > 0;

    if (!hasPreviousData) {
      this.loading = true; // Solo muestra loading si no hay datos previos
    }

    const request$ = employee
      ? this._appSolicitudesService.getAllModelsByEmployee(employee, companyCode, companyId)
      : this.dateFilterReq
        ? this._appSolicitudesService.getAllModelsByDate(date)
        : this._appSolicitudesService.getAllModels();

    request$.subscribe(
      (data) => {

        // Guardar el mayor rango 
        const currentDate = date || new Date();
        const newStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 4, 1);
        const newEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 5, 0);

        if (!this.dateFilterStart || newStartDate < this.dateFilterStart) {
          this.dateFilterStart = newStartDate;
        }
        if (!this.dateFilterEnd || newEndDate > this.dateFilterEnd) {
          this.dateFilterEnd = newEndDate;
        }

        let filteredData = data.filter((item: any) => {
          const tipoEvento = item.type.trim().toLowerCase();
          return !["cambio de datos", "anticipo"].includes(tipoEvento);
        });


        if (reOpenCalendar) {
          if (this.filtros.tipo.length) {
            filteredData = filteredData.filter((item: any) => this.filtros.tipo.includes(item.type));
          }

          if (this.filtros.empleado.length) {
            filteredData = filteredData.filter((item: any) => this.filtros.empleado.includes(item.user.fullName));
          }

          if (this.filtros.empresa.length) {
            filteredData = filteredData.filter((item: any) => this.filtros.empresa.includes(item.company.name));
          }

          if (this.filtros.estado.length) {
            filteredData = filteredData.filter((item: any) => this.filtros.estado.includes(item.stateHr?.name));
          }
        }

        //Tratar las solicitudes para sobreescribirlas o añadirlas dependeindo seis e filtra por fecha o no 

        const newAppointments = filteredData.map((item: any) => {
          const start = new Date(item.startDate);
          const end = new Date(item.endDate);

          const formatTime = (date: Date) =>
            date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });

          return {
            ...item,
            text: item.user?.fullName || '',
            startDate: start,
            endDate: end,
            roomId: item.stateHr?.requestState1,
            type: item.type,
            profileImage: item.user?.profileImage?.imageData,
            icon: iconSelect[item.type] ?? 'certificate',
            allDay: item.duration === null,
            timeRange: `${formatTime(start)} - ${formatTime(end)}`
          };
        });

        if (this.dateFilterReq) {
          //Si `dateFilterReq` es `true`, fusiona los datos
          const appointmentsMap = new Map(this.inputData.appointments.map((item: any) => [item.request1, item]));

          newAppointments.forEach((appointment) => {
            appointmentsMap.set(appointment.request1, appointment); // Si ya existe, se actualiza
          });

          this.inputData.appointments = Array.from(appointmentsMap.values()); // Convierte el mapa a array
        } else {
          //Si `dateFilterReq` es `false`, sobrescribe los datos
          this.inputData.appointments = newAppointments;
        }

        this.getUniqueValues();
        this.aplicarFiltros();
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }



  getUniqueValues() {
    const empleadosSet = new Set<string>();
    const empresasSet = new Set<string>();
    const centrosSet = new Set<string>();
    const tiposSet = new Set<string>();

    this.inputData.appointments.forEach((item: any) => {
      if (item.user?.fullName && item.company?.name) {
        empleadosSet.add(`${item.user.fullName} (${item.company.name})`);
      }

      if (item.company?.name) empresasSet.add(item.company.name);

      if (Array.isArray(item.user?.imputationData)) {
        item.user.imputationData.forEach(data => {
          if (data.imputationName) {
            centrosSet.add(`${data.imputationName} (${item.company.name})`);
          }
        });
      }

      if (item.type && !["Cambio de datos", "Anticipo"].includes(item.type)) {
        tiposSet.add(item.type);
      }
    });

    this.empleados = Array.from(empleadosSet).sort();
    this.empresas = Array.from(empresasSet).sort();
    this.centros = Array.from(centrosSet).sort();
    this.tipos = Array.from(tiposSet).sort();
  }

  mostrarLeyendaPopup = () => {
    this._messageDialog.ShowInfoHTML(` 
      <div class="scheduler-legend" style="display: flex; flex-direction: column; gap: 8px; padding: 10px;">
      <div class="legend-item legend-item-holiday" style="display: flex; align-items: center; gap: 10px; font-size: 14px; color: #fff; background-color: #eb8f00; padding: 5px 10px; border-radius: 5px;">
          <span style="font-weight: bold;">Pendiente </span>
        </div>
        <div class="legend-item legend-item-absence" style="display: flex; align-items: center; gap: 10px; font-size: 14px; color: #fff; background-color: #4caf50; padding: 5px 10px; border-radius: 5px;">
          <span style="font-weight: bold;">Aceptado </span>
        </div>
        <div class="legend-item legend-item-today" style="display: flex; align-items: center; gap: 10px; font-size: 14px; color: #fff; background-color: #d63939; padding: 5px 10px; border-radius: 5px;">
          <span style="font-weight: bold;">Rechazado </span>
        </div>
        
      <p style="text-align: left; margin-top: 1em; font-size: 0.9em"><span style="color:red">*</span> Por defecto solo se muestran las solicitudes con estado <b>"Pendiente"</b> y <b>"Aceptado"</b></p>
      </div>
    `, 'Estado RRHH');
  };

  abrirFiltros() {
    this.popupVisible = true; // Muestra el popup
  }

  aplicarFiltros() {
    let filtrados = this.inputData.appointments.filter((item: any) => {
      const tipoEvento = item.type.trim().toLowerCase();
      const tiposSeleccionados = this.filtros.tipo.map((t: string) => t.trim().toLowerCase());

      if (tipoEvento === "cambio de datos" || tipoEvento === "anticipo") {
        return false;
      }

      return tiposSeleccionados.length === 0 || tiposSeleccionados.includes(tipoEvento);
    });

    // Filtrar por empresa
    if (this.filtros.empresa.length > 0) {
      filtrados = filtrados.filter((item: any) => this.filtros.empresa.includes(item.company.name));
    }

    // Filtrar por usuario, pero permitir registros de empresas que no tengan usuarios seleccionados
    if (this.filtros.empleado.length > 0) {
      const empresasConUsuariosSeleccionados = new Set(
        this.filtros.empleado.map((empleado: string) => empleado.split(' (')[1]?.replace(')', ''))
      );

      filtrados = filtrados.filter((item: any) =>
        this.filtros.empleado.includes(`${item.user.fullName} (${item.company.name})`) ||
        (this.filtros.empresa.includes(item.company.name) && !empresasConUsuariosSeleccionados.has(item.company.name))
      );
    }

    // Filtrar por estado y centro
    filtrados = filtrados.filter((item: any) =>
      this.filtros.estado.length === 0 || this.filtros.estado.includes(item.stateHr?.name)
    );

    filtrados = filtrados.filter((item: any) =>
      this.filtros.centro.length === 0 ||
      (Array.isArray(item.user?.imputationData) &&
        item.user.imputationData.some((data: any) => this.filtros.centro.includes(data.imputationName)))
    );

    this.appointments = filtrados.map((item: any) => {
      const start = new Date(item.startDate);
      const end = new Date(item.endDate);

      const formatTime = (date: Date) =>
        date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });

      return {
        ...item,
        text: item.user?.fullName || '',
        startDate: start,
        endDate: end,
        roomId: item.stateHr?.requestState1,
        type: item.type,
        profileImage: item.user?.profileImage?.imageData,
        icon: iconSelect[item.type] ?? 'certificate',
        allDay: item.duration === null,
        timeRange: `${formatTime(start)} - ${formatTime(end)}`
      };
    });

    this.popupVisible = false;
  }






  limpiarFiltros() {
    this.filtros = { tipo: [], empleado: [], empresa: [], estado: [], centro: [] };
    this.aplicarFiltros();
  }

  getAppointmentColor(appointment: any): string {
    const resource = this.resourcesData.find(r => r.id === appointment.roomId);
    return resource ? resource.color : '#007ac3';
  }

  private applyDialogStyles(indexes: number[]) {
    const dialogContainers = this.document.querySelectorAll('.mat-dialog-container');
    indexes.forEach(index => {
      if (dialogContainers[index]) {
        this.renderer.setStyle(dialogContainers[index], 'background-color', '#dadada');
        this.renderer.setStyle(dialogContainers[index], 'max-height', '90vh');
        this.renderer.setStyle(dialogContainers[index], 'overflow-y', 'auto');
        this.renderer.addClass(dialogContainers[index], 'scrollable-section');
      }
    });
  }

  private canEditRequest(appointment: any): boolean {
    const userLogged = this._livesSession.AspNetUserId;

    const enabledHolidayBagValidator = appointment.associatedHolidayBag?.holidayBagValidatorData?.hostelUserId === userLogged;
    const enabledValidator = appointment.hrValidators?.some((validator: any) => validator.hostelUserId === userLogged);
    const advanceValidator = appointment.associatedAdvanceRequest?.validatedByData?.hostelUserId === userLogged;

    return enabledHolidayBagValidator || enabledValidator || advanceValidator;
  }

  actualizarEmpleados = (e: any) => {
    this.filtros.empresa = e.value; // Actualiza el filtro de empresa seleccionado

    const empleadosSet = new Set<string>();

    this.inputData.appointments.forEach((item: any) => {
      if (
        (!this.filtros.empresa.length || this.filtros.empresa.includes(item.company?.name)) &&
        item.user?.fullName &&
        item.company?.name
      ) {
        empleadosSet.add(`${item.user.fullName} (${item.company.name})`);
      }
    });

    // Obtener los empleados válidos con la nueva selección de empresas
    const empleadosValidos = Array.from(empleadosSet).sort();

    // Filtrar empleados seleccionados que ya no pertenecen a empresas seleccionadas
    this.filtros.empleado = this.filtros.empleado.filter(empleado =>
      empleadosValidos.includes(empleado)
    );

    // Actualizar la lista de empleados disponibles
    this.empleados = empleadosValidos;
  };


  getDateFilterAlert(): string {
    if (!this.dateFilterReq || !this.dateFilterStart || !this.dateFilterEnd) return '';

    const formatMonthYear = (date: Date) => {
      const formattedDate = date.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    };

    return `Mostrando solicitudes desde ${formatMonthYear(this.dateFilterStart)} hasta ${formatMonthYear(this.dateFilterEnd)}`;
  }






}